<template><el-card shadow="never" class="aui-card--fill">
  <el-form :inline="true" :model="dataForm">
    <el-form-item>
      <el-select
        v-model="dataForm.agentId"
        filterable
        remote
        clearable
        :remote-method="searchAgents"
        :loading="agentLoading"
        placeholder="请输入代理用户名"
        style="width: 260px;">
        <el-option
          v-for="agent in agentOptions"
          :key="agent.id"
          :label="agentLabel(agent)"
          :value="agent.id" />
      </el-select>
    </el-form-item>
    <el-form-item><el-input v-model="dataForm.sourceAccount" placeholder="来源账号" clearable/></el-form-item>
    <el-form-item><el-select v-model="dataForm.status" placeholder="状态" clearable>
      <el-option label="待结算" :value="1"/>
      <el-option label="已结算" :value="2" />
    </el-select>
    </el-form-item>
    <el-form-item><el-date-picker v-model="range" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间" @change="rangeChange"/></el-form-item>
    <el-form-item><el-button @click="search">查询</el-button></el-form-item>
  </el-form>
  <el-row :gutter="16" style="margin-bottom:16px"><el-col v-for="(v,k) in stats" :key="k" :span="6"><el-card shadow="hover"><div style="color:#909399">{{ statLabel(k) }}</div><div style="font-size:22px;margin-top:8px">{{ v }}</div></el-card></el-col></el-row>
  <el-table v-loading="loading" :data="dataList" border>
    <el-table-column prop="recordNo" label="流水号" width="190"/>
    <el-table-column label="代理账号" min-width="150">
      <template slot-scope="scope">
        <div class="agent-account">{{ scope.row.agent_username || '-' }}</div>
        <div class="agent-nickname">{{ scope.row.agent_nickname || '-' }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="sourceAccount" label="来源账号"/>
    <el-table-column prop="orderNo" label="订单号" width="180"/>
    <el-table-column prop="orderAmount" label="订单金额"/>
    <el-table-column prop="commissionRatio" label="返佣比例">
      <template v-slot="scope">{{ scope.row.commissionRatio }}%</template>
    </el-table-column>
    <el-table-column prop="commissionAmount" label="返佣金额"/>
    <el-table-column prop="status" label="状态">
      <template v-slot="s">{{ s.row.status === 1 ? '待结算' : '已结算' }}</template>
    </el-table-column>
    <el-table-column prop="settleTime" label="结算时间" width="180"/>
    <el-table-column prop="createTime" label="创建时间" width="180"/>
  </el-table>
  <el-pagination :current-page="page" :page-size="limit" :total="total" :page-sizes="[10,20,50,100]" layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChange" @current-change="currentChange"/>
</el-card></template>
<script>
import agentPage from '@/mixins/agent-page'

export default {
  mixins: [agentPage],
  data () {
    return {
      pageUrl: '/agent-commission/page',
      dataForm: {
        agentId: '',
        status: '',
        sourceAccount: '',
        startTime: '',
        endTime: ''
      },
      agentLoading: false,
      agentOptions: [],
      range: [],
      stats: {}
    }
  },
  methods: {
    searchAgents (username) {
      const keyword = username.trim()
      if (!keyword) {
        this.agentOptions = []
        return
      }

      this.agentLoading = true
      this.$http.get('/agent/page', {
        params: {
          username: keyword,
          page: 1,
          limit: 20
        }
      }).then(({ data }) => {
        if (data.code !== 0) {
          this.agentOptions = []
          return this.$message.error(data.msg)
        }
        this.agentOptions = data.data.list || []
      }).finally(() => {
        this.agentLoading = false
      })
    },
    agentLabel (agent) {
      const nickname = agent.nickname ? ` - ${agent.nickname}` : ''
      return `${agent.username}${nickname}（ID: ${agent.id}）`
    },
    rangeChange (value) {
      this.dataForm.startTime = value ? value[0] : ''
      this.dataForm.endTime = value ? value[1] : ''
    },
    statLabel (key) {
      return ({
        totalCommission: '返佣总额',
        todayCommission: '今日返佣',
        pendingAmount: '待结算',
        recordCount: '流水数',
        todayOrderAmount:'今日存款总量',
        orderAmount: '存款总金额',
      })[key] || key
    }
  }
}
</script>
